import axios from 'axios'
import { db } from '../firebase'
import { config } from '../config'

export function stripe(data) {
    return dispatch => {
        dispatch({type: "PAYMENT_STRIPE"})
        axios.post(`${config.backend}/stripe`, data)
          .then(function (response) {
            dispatch({type: "PAYMENT_STRIPE_FULFILLED", payload: response})
          })
          .catch(function (error) {
            dispatch({type: "PAYMENT_STRIPE_REJECTED", payload: error})
          });
    }
}

export function transactionsListener(uid) {
    return dispatch => {
    dispatch({type: "TRANSACTIONS"})
    let doc = db.collection(`users/${uid}/transactions`)
    let observer = doc.onSnapshot(docSnapshot => {
            let allData = []
            docSnapshot.forEach(doc => {
                allData.push(doc.data())
              });
            dispatch({type: "TRANSACTIONS_FULFILLED", payload: allData})
        //   console.log(`Received doc snapshot: ${docSnapshot}`);
          // ...
        }, err => {
          console.log(`Encountered error: ${err}`);
        });

    }
}

export function payWithTweet(uid, name, email) {
  return dispatch => {
    dispatch({type: "PAYWITHTWEET"})
    axios.get(`${config.backend}/paywithtweet?uid=${uid}&email=${email}&name=${name}`)
    .then(function (response) {
      dispatch({type: "PAYWITHTWEET_FULFILLED", payload: response})
    })
    .catch(function (error) {
      dispatch({type: "PAYWITHTWEET_REJECTED", payload: error})
    });
}}

export function promocode(uid, name, email, code) {
  return dispatch => {
    dispatch({type: "PROMOCODE"})
    axios.get(`${config.backend}/promocode?uid=${uid}&email=${email}&name=${name}&code=${code}`)
    .then(function (response) {
      dispatch({type: "PROMOCODE_FULFILLED", payload: response})
    })
    .catch(function (error) {
      dispatch({type: "PROMOCODE_REJECTED", payload: error})
    });
}}


// WEBPACK FOOTER //
// ./src/actions/paymentActions.js